package no.vareflow.app.domain

/**
 * A calendar month stored as `YYYY-MM` (the format used in sessions, Firestore and local storage).
 * Replaces java.time.YearMonth so the rules also run in the browser.
 */
data class YearMonthValue(val year: Int, val month: Int) : Comparable<YearMonthValue> {
    init {
        require(month in 1..12) { "month must be 1..12" }
    }

    fun plusMonths(count: Int): YearMonthValue {
        val index = year * 12 + (month - 1) + count
        return YearMonthValue(index.floorDiv(12), index.mod(12) + 1)
    }

    override fun compareTo(other: YearMonthValue): Int =
        compareValuesBy(this, other, { it.year }, { it.month })

    override fun toString(): String =
        "${year.toString().padStart(4, '0')}-${month.toString().padStart(2, '0')}"

    companion object {
        private val PATTERN = Regex("""(\d{4})-(\d{2})""")

        /** Strict `YYYY-MM` (as java.time.YearMonth.parse accepted); null for anything else. */
        fun parse(value: String): YearMonthValue? {
            val match = PATTERN.matchEntire(value) ?: return null
            val month = match.groupValues[2].toInt()
            if (month !in 1..12) return null
            return YearMonthValue(match.groupValues[1].toInt(), month)
        }
    }
}
